<template>
  <div class="deal-page">
    欢迎使用灵云产品（以下简称“本软件”）及服务，请您（以下可称“用户”或“您”）仔细阅读以下条款。
    本协议是您与北京捷通华声科技股份有限公司（以下简称“捷通华声”）之间订立的，关于您使用、下载、安装本软件，以及使用捷通华声相关服务所订立的协议。
    当您在使用灵云产品服务时（包括但不限于点击“注册/登录”按钮），您的使用行为视为对该项服务条款以及捷通华声在该项服务中发出的各类公告的同意。其中，免除或限制责任条款等重要内容以通过加粗形式提示您注意，您应重点阅读。如您不同意本服务协议及/或随时对其的修改，您可以停止登录或使用灵云产品服务；您一旦使用捷通华声灵云产品服务，即视为您已了解并完全同意本服务协议各项内容，包括捷通华声对服务协议随时所做的任何修改，并成为捷通华声用户。
    捷通华声灵云产品用户协议可由捷通华声公司随时更新，您须定期审阅。
    一、产品及服务内容
    1.1灵云产品服务包括但不限于：在电脑或移动端安装的灵云产品客户端、灵云产品的相关网站、及捷通华声通过灵云产品提供的所有服务。同时，捷通华声会不断丰富灵云产品服务的终端、形式、内容等，并会对软件进行更新迭代。当您使用灵云产品服务时，应选择与其终端、系统等相匹配的软件版本，否则，可能无法正常使用。
    1.2
    除非本服务协议另有其它明示规定，捷通华声所推出的新产品、新功能、新服务，均受到本服务协议之规范。
    1.3为使用本服务，您必须能够自行经有合法资格对您提供互联网接入服务的第三方，进入国际互联网，并应自行支付相关服务费用。此外，您必须自行配备及负责与国际联网连线所需之一切必要装备，包括计算机、移动设备或其它存取装置。
    二、账号与注册
    2.1您注册成功后，捷通华声将给予您一个用户帐号及相应的密码，该用户帐号和密码由您负责保管；您应当对以您的用户帐号进行的所有活动和事件负法律责任。
    2.2捷通华声用户帐号的所有权归捷通华声，您完成注册申请手续后，获得捷通华声用户帐号的使用权。您应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题以及对问题发生所带来的后果，捷通华声不负任何责任。
    2.3您不应将您的用户帐号、密码转让、出售或出借予他人使用。如果捷通华声发现或者有合理理由认为使用者并非帐号注册者本人，为保护账号的安全，捷通华声有权停止继续服务。如您发现您的用户帐号遭他人非法使用，
    应立即通知捷通华声。因黑客行为或您违反本协议规定导致帐号、密码遭他人非法使用，由您本人承担因此导致的损失和一切法律责任，捷通华声不承担任何责任。
    2.4您可以申请注销账号。在您注销账号后，捷通华声将停止提供依赖账号登录的产品和服务，除法律法规另有规定外，捷通华声将删除或匿名化处理您的个人信息及数据。因此，您理解并同意，在注销账户后，捷通华声将无法恢复您账户的任何相关信息。
    三、用户使用规则
    3.1您在使用捷通华声灵云产品服务时，必须遵守中华人民共和国相关法律法规的规定，您应同意将不会利用本服务进行任何违法或不正当的活动。您在使用捷通华声灵云产品服务时所上传、展示、制作或发布的信息（包括不限于音频、视频、图像、文本、链接、注册信息、评论等），不得含有下列内容之一的信息：
    （1）反对宪法所确定的基本原则的；
    （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
    （3）损害国家荣誉和利益的；
    （4）煽动民族仇恨、民族歧视、破坏民族团结的；
    （5）破坏国家宗教政策，宣扬邪教和封建迷信的；
    （6）散布谣言，扰乱社会秩序，破坏社会稳定的；
    （7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
    （8）侮辱或者诽谤他人，侵害他人合法权利的；
    （9）含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；
    （10）含有法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。
    3.2 您在使用捷通华声灵云产品服务时，不得为任何非法目的而使用网络服务系统。
    3.3 您在使用捷通华声灵云产品服务时，不得利用捷通华声提供的服务从事以下活动：
    （1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；
    （2）未经允许，对计算机信息网络功能进行删除、修改或者增加的；
    （3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；
    （4）故意制作、传播计算机病毒等破坏性程序的；
    （5）其他危害计算机信息网络安全的行为。 3.4
    若您违反本协议或相关的服务条款的规定，捷通华声有权视您的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收捷通华声用户帐号、追究法律责任等措施。对恶意注册捷通华声用户帐号或利用捷通华声用户帐号进行违法活动、捣乱、骚扰、欺骗其他用户以及其他违反本协议的行为，捷通华声有权回收其帐号。
    若您在捷通华声灵云产品服务上散布和传播反动、色情或其他违反国家法律的信息，捷通华声系统记录有可能作为违反法律的证据，同时会视司法部门的要求，协助调查。
    3.5
    您须对自己在使用捷通华声服务过程中的行为承担法律责任。因您的违法或违约行为，引起第三方投诉或诉讼索赔的，您应当自行处理并承担可能因此产生的全部法律责任。因此导致捷通华声公司遭受行政处罚或承担赔偿责任的，您应赔偿捷通华声公司因此遭受的全部损失，包括合理的律师费。
    四、数据与隐私保护 4.1
    捷通华声将采取业界内严格的保密措施保护用户的信息不被未经授权的访问、使用或泄漏。捷通华声不对外公开或向第三方提供您的注册资料及个人信息，除非：
    （1）事先获得您的明确授权；
    （2）只有共享您的个人资料，才能提供您所要求的产品和服务；
    （3）根据有关的法律法规要求或相关政府主管部门的要求；
    （4）为维护社会公共利益；
    （5）为维护捷通华声及其合作伙伴、关联公司、其他用户的人身财产安全及其他合法权益等合理且必要的用途。
    4.2
    在注册捷通华声用户帐户，使用灵云产品或服务（包括不限于客户端、网页等），或使用捷通华声灵云产品服务进行的任何活动时，捷通华声有权收集您的个人身份识别资料，并会将这些资料用于改进为您提供的服务或其他内容。
    五、服务费用 5.1
    您理解并同意捷通华声有权根据市场、成本等因素对目前的收费方式、支付渠道、收费标准进行合理调整，有权对部分目前免费的服务项目收取合理的服务费，有权对新增的产品或服务决定是否收费。如您不同意捷通华声收取此项目费用，则您有权退出使用该项服务或终止使用捷通华声灵云产品服务。
    5.2
    如您接受捷通华声的收费项目，则您应当按捷通华声的收费规定支付费用；如您未支付费用或欠费，则捷通华声有权暂停或停止向您提供此项服务。
    5.3
    捷通华声在收费项目的页面提示收费标准，并在确认支付前提示使用本服务请求所需的相应费用。您一旦确认支付，即代表您知晓并同意该服务所产生的相应费用。
    5.4
    您理解并同意，基于虚拟商品的特性，您在捷通华声所购买的虚拟商品（包括不限于VIP会员、语音转写服务、语音合成服务、时长卡券、云币等），一旦订单生成并完成支付，捷通华声不接受任何形式的取消、退款、退货、换货、兑换现金等。如您对服务费用有任何疑问，可在本软件的相关界面联系客服咨询。
    六、知识产权 6.1
    捷通华声拥有本软件内所有资料的版权（包括不限于文本、图像、图形、界面、标识、声音、版面设计、商标、计算机程序等）。任何被授权的浏览、复制、打印和传播属于本网站内的资料必须同时符合以下条件：
    （1）所有的资料和图像均以获得信息为目的；
    （2）所有的资料和图像均不得用于商业目的；
    （3）所有的资料和图像及其任何部分都必须包括此版权声明，不得删除、掩盖或更改版权声明、商标或其它知识产权声明；
    （4）本软件所有的产品、技术以及所有程序均属于捷通华声知识产权。
    （5）“HCICloud”、“AIcloud”、“灵云”、“捷通华声”及相关图形等为捷通华声的注册商标。未经捷通华声许可，任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用。否则，捷通华声将依法追究法律责任。
    6.2
    您承诺，您对您在使用灵云产品服务时上传、保存、分享、下载或使用的内容（包括不限于文字、图像、音频、视频等）拥有著作权或者已经取得了合法授权，并且该内容不会违反任何国家法律法规、也不会侵犯任何第三方的合法权益。如您违反上述承诺，您将独立承担一切责任及赔偿给捷通华声造成的损失。
    6.3
    对于您通过捷通华声服务上传到捷通华声网站或应用上可公开获取的内容（不涉及个人未公开信息和隐私），您同意捷通华声在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。
    七、免责声明 7.1
    鉴于网络服务的特殊性，您同意捷通华声有权随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。捷通华声不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。
    7.2
    为更好地为您提供服务，捷通华声需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，捷通华声无需为此承担任何责任。
    7.3对于因不可抗力或捷通华声不能控制的原因（包括不限于自然灾害、政府法规、战争、电信运营商的故障、计算机病毒、黑客攻击、停电等）造成的网络服务中断或其它缺陷，捷通华声不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
    7.4
    您明确同意使用捷通华声网络服务所存在的风险将完全由您自己承担，因您使用捷通华声网络服务而产生的一切后果也由您自己承担，捷通华声对您不承担任何责任。您理解并接受下载或通过捷通华声服务取得的任何信息资料取决于您自己，并由您承担系统受损、资料丢失以及其它任何风险。
    7.5
    您理解并同意，您在本软件中使用的第三方提供的软件、技术或其他相关服务时，除遵守本协议中其他相关规则外，您还需同意并遵守第三方的协议及相关规则。如因第三方软件、技术及相关服务产生的争议，应由您自行与第三方解决，捷通华声不承担任何责任。
    7.6
    受限于当前科学技术发展，捷通华声灵云产品会不断致力于提升软件服务水平，但不保证本软件在录音、转写、识别、翻译、合成等服务的过程中不会出现任何错误。
    7.7本软件及服务仅限于在中国大陆地区使用，如果您擅自在中国大陆以外（特别是欧盟）地区使用，捷通华声不承担任何责任。
    八、广告 8.1
    您了解并同意在使用本产品及服务的过程中，捷通华声可能会向您发出的其他产品的推广消息，包括但不限于商品促销等推广信息。
    8.2
    捷通华声依照法律的规定及相关合作协议履行广告及推广相关义务，您应当自行判断广告信息的真实性和可靠性并为自己的判断行为负责，除法律明确规定外，您因该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，捷通华声不承担责任。
    九、身份限制
    9.1您确认，您是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述相适应的民事行为能力或未满十八周岁，请在您的监护人的陪同下阅读本服务条款，并在取得他们同意之后使用本产品和服务；如您违反本协议或法律法规的规定的，捷通华声有权要求您及您的监护人承担全部法律责任。
    十、服务终止
    10.1捷通华声发现或收到他人举报或投诉您违反本协议约定的，捷通华声有权根据您的行为性质，采取包括但不限于暂停或终止本服务（或其任何部分），并将您在本服务内任何内容加以移除并删除。
    10.2您充分理解并同意，捷通华声有权依合理判断对违反有关法律法规或本协议规定的行为进行处理。对您的违法违规行为，捷通华声有权在不进行事先通知的情况下即可中断或终止服务，有权立即关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。在上述情况下，捷通华声无需对您或任何第三人承担任何责任。
    十一、其他 11.1
    本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。 11.2
    如双方就本协议内容或本协议的执行发生任何争议，应尽量友好协商解决；协商不成的，
    任何一方均可向捷通华声所在地的人民法院提起诉讼。 11.3
    捷通华声未行使或执行的本协议任何权利或规定，不构成对前述权利或规定的放弃。
    11.4
    如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并具有约束力。
    请您在发现任何违反本服务协议以及其他任何服务条款或公告之情形时，通知捷通华声。您可以通过如下方式联系捷通华声：
    地址：北京市海淀区东北旺北京中关村软件园孵化器2号楼一层2101室
    电话：010-82826886 邮箱：aicloud_support@sinovoice.com.cn 邮编：100193
    北京捷通华声科技股份有限公司
  </div>
</template>

<script>
export default {
  mounted () {
    document.title = '用户协议'
  }
}
</script>

<style lang="scss" scoped>
.deal-page {
  padding: 40px 32px;
}
</style>
